// import axios from 'axios'; // axios
import * as types from '../mutation-types';
import { deepCopy, arrayToTree } from 'jyutils/utils';
import { doGet } from '@/axios/http';

const state = {
  loading: {
    xiaoquList: false,
    xiaoquMap: false,
    sexList: false,
    sexMap: false,
    ccList: false,
    xjList: false,
    xjMap: false,
    xjStatus: false,
    preconditionList: false,
    sourceMap: false,
    cluestatusMap: false,
    visitstatusMap: false,
    visittypeMap: false,
    idcardtype: false,
    bodystate: false,
    zyList: false,
    yxList: false,
    kcList: false,
    xlMap: false,
    zslsList: false,
    njList: false,
    bfeeList: false,
    feetagList: false,
    feetagList2: false,
    paymethodMap: false,
    exportList: false,
    sealtypeList: false,
    contracttypeList: false,
    contractstateList: false,
    mzList: false,
    zzmmList: false,
    pxitemList: false,
    empList: false,
    departList: false,
    goodscateList: false,
    goodsunitList: false,
    goodsbrandList: false,
    jilucateList: false,
    huiyishicateList: false,
    huiyishiroomList: false,
    scoreterm: false,
    scorekstype: false,
  },
  xiaoquList: null,
  xiaoquMap: null,
  sexList: null,
  sexMap: null,
  ccList: null,
  xjList: null,
  xjMap: null,
  xjStatus: null,
  preconditionList: null,
  sourceMap: null,
  cluestatusMap: null,
  visitstatusMap: null,
  visittypeMap: null,
  idcardtype: null,
  bodystate: null,
  zyList: null,
  yxList: null,
  kcList: null,
  xlMap: null,
  zslsList: null,
  njList: null,
  bfeeList: null,
  feetagList: null,
  feetagList2: null,
  paymethodMap: null,
  exportList: null,
  sealtypeList: null,
  contracttypeList: null,
  contractstateList: null,
  mzList: null,
  zzmmList: null,
  pxitemList: null,
  pxitemTree: null,
  empList: null,
  departList: null,
  goodscateList: null,
  goodsbrandList: null,
  goodsunitList: null,
  jilucateList: null,
  huiyishicateList: null,
  huiyishiroomList: null,
  scoreterm: null,
  scorekstype: null,
};

const getters = {
  [types.BASE_LOAD.baseLoading]: (state) => {
    return state.loading;
  },
  [types.BASE_LOAD.xiaoquList]: (state) => {
    return state.xiaoquList || [];
  },
  [types.BASE_LOAD.xiaoquMap]: (state) => {
    let map = {};
    if (!state.xiaoquList) {
      return map;
    }
    state.xiaoquList.forEach(item => {
      map[item.id] = item;
    });
    return map;
  },
  [types.BASE_LOAD.sexList]: (state) => {
    return state.sexList || [];
  },
  [types.BASE_LOAD.sexMap]: (state) => {
    let map = {};
    if (!state.sexList) {
      return map;
    }
    state.sexList.forEach(item => {
      map[item.id] = item;
    });
    return map;
  },
  [types.BASE_LOAD.ccList]: (state) => {
    return state.ccList || [];
  },
  [types.BASE_LOAD.xjList]: (state) => {
    return state.xjList || [];
  },
  [types.BASE_LOAD.xjMap]: (state) => {
    let map = {};
    if (!state.xjList) {
      return map;
    }
    state.xjList.forEach(item => {
      map[item.id] = item;
    });
    return map;
  },
  [types.BASE_LOAD.xjStatus]: (state) => {
    let map = {};
    if (!state.xjStatus) {
      return map;
    }
    state.xjStatus.forEach(item => {
      map[item.code] = {name:item.name, color:item.color};
    });
    return map;
  },
  [types.BASE_LOAD.preconditionList]: (state) => {
    return state.preconditionList;
  },
  [types.BASE_LOAD.sourceMap]: (state) => {
    let map = {};
    if (!state.sourceMap) {
      return map;
    }
    state.sourceMap.forEach(item => {
      map[item.code] = item.name;
    });
    return map;
  },
  [types.BASE_LOAD.cluestatusMap]: (state) => {
    let map = {};
    if (!state.cluestatusMap) {
      return map;
    }
    state.cluestatusMap.forEach(item => {
      map[item.code] = item.name;
    });
    return map;
  },
  [types.BASE_LOAD.visitstatusMap]: (state) => {
    let map = {};
    if (!state.visitstatusMap) {
      return map;
    }
    state.visitstatusMap.forEach(item => {
      map[item.code] = item.name;
    });
    return map;
  },
  [types.BASE_LOAD.visittypeMap]: (state) => {
    let map = {};
    if (!state.visittypeMap) {
      return map;
    }
    state.visittypeMap.forEach(item => {
      map[item.code] = item.name;
    });
    return map;
  },
  [types.BASE_LOAD.idcardtype]: (state) => {
    let map = {};
    if (!state.idcardtype) {
      return map;
    }
    state.idcardtype.forEach(item => {
      map[item.code] = item.name;
    });
    return map;
  },
  [types.BASE_LOAD.bodystate]: (state) => {
    let map = {};
    if (!state.bodystate) {
      return map;
    }
    state.bodystate.forEach(item => {
      map[item.code] = item.name;
    });
    return map;
  },
  [types.BASE_LOAD.zyList]: (state) => {
    return state.zyList || [];
  },
  [types.BASE_LOAD.yxList]: (state) => {
    return state.yxList || [];
  },
  [types.BASE_LOAD.kcList]: (state) => {
    return state.kcList || [];
  },
  [types.BASE_LOAD.xlMap]: (state) => {
    let map = {};
    if (!state.xlMap) {
      return map;
    }
    state.xlMap.forEach(item => {
      map[item.code] = item.name;
    });
    return map;
  },
  [types.BASE_LOAD.zslsList]: (state) => {
    return state.zslsList || [];
  },
  [types.BASE_LOAD.njList]: (state) => {
    return state.njList || [];
  },
  [types.BASE_LOAD.bfeeList]: (state) => {
    return state.bfeeList || [];
  },
  [types.BASE_LOAD.feetagList]: (state) => {
    return state.feetagList == null ? [] : state.feetagList.filter(d => d.isprimary);
  },
  [types.BASE_LOAD.feetagList2]: (state) => {
    return state.feetagList == null ? [] : state.feetagList.filter(d => !d.isprimary);
  },
  [types.BASE_LOAD.paymethodMap]: (state) => {
    let map = {};
    if (!state.paymethodMap) {
      return map;
    }
    state.paymethodMap.forEach(item => {
      map[item.code] = item.name;
    });
    return map;
  },
  [types.BASE_LOAD.exportList]: (state) => {
    return state.exportList || [];
  },
  [types.BASE_LOAD.sealtypeList]: (state) => {
    return state.sealtypeList || [];
  },
  [types.BASE_LOAD.contracttypeList]: (state) => {
    return state.contracttypeList || [];
  },
  [types.BASE_LOAD.contractstateList]: (state) => {
    return state.contractstateList || [];
  },
  [types.BASE_LOAD.mzList]: (state) => {
    return state.mzList || [];
  },
  [types.BASE_LOAD.zzmmList]: (state) => {
    return state.zzmmList || [];
  },
  [types.BASE_LOAD.pxitemList]: (state) => {
    return state.pxitemList || [];
  },
  [types.BASE_LOAD.pxitemTree]: (state) => {
    if (!state.pxitemList) {
      return [];
    }
    let arr = deepCopy(state.pxitemList);
    return arrayToTree(arr);
  },
  [types.BASE_LOAD.empList]: (state) => {
    return state.empList || [];
  },
  [types.BASE_LOAD.departList]: (state) => {
    return state.departList || [];
  },
  [types.BASE_LOAD.goodscateList]: (state) => {
    return state.goodscateList || [];
  },
  [types.BASE_LOAD.goodsbrandList]: (state) => {
    return state.goodsbrandList || [];
  },
  [types.BASE_LOAD.goodsunitList]: (state) => {
    return state.goodsunitList || [];
  },
  [types.BASE_LOAD.jilucateList]: (state) => {
    return state.jilucateList || [];
  },
  [types.BASE_LOAD.huiyishicateList]: (state) => {
    return state.huiyishicateList || [];
  },
  [types.BASE_LOAD.huiyishiroomList]: (state) => {
    return state.huiyishiroomList || [];
  },
  [types.BASE_LOAD.scoreterm]: (state) => {
    return state.scoreterm || [];
  },
  [types.BASE_LOAD.scorekstype]: (state) => {
    return state.scorekstype || [];
  },
};

const mutations = {
  setState(state, args) {
    state[args.type] = args.json;
    state.loading[args.loading] = false;
  },
}

const actions = {
  loadOthers({ dispatch, state }, param) {
    if (!param.type || state.loading[param.type] === undefined) {
      param && param.callback && (param.callback.call(this, 'Missing type parameters!'));
      return Promise.reject();
    } else {
      param.params = Object.assign({}, param.params || {});
      return dispatch('loadBase', { url: param.url, param: param });
    }
    // if (!param.type || state.loading[param.type] === undefined) {
    //   param && param.callback && (param.callback.call(this, 'Missing type parameters!'));
    // } else {
    //   param.params = Object.assign({}, param.params || {});
    //   dispatch('loadBase', { url: param.url, param: param });
    // }
  },
  loadBase({ commit, state, rootState }, param) {
    return new Promise((resolve, reject) => {
      let params = param.param;
      if (!state[params.list || params.obj] || (params.reload)) {
        state.loading[params.type] = true;
        doGet({
          url: param.url,
          data: params.params,
          headers: {Authorization: rootState.token},
          okcb: json => {
            commit('setState', { type: params.type, loading: params.loading || params.type, json: json || (params.list ? [] : {}) });
  
            params && params.callback && (params.callback(json || (params.list ? [] : {})));

            resolve(json || (params.list ? [] : {}));
          },
          errcb: json => {
            params && params.callback && (params.callback(json || '服务器错误！'));
            state.loading[params.type] = false;
            reject();
          }
        });
      } else {
        reject();
      }
    });

    // let params = param.param;
    // if (!state[params.list || params.obj] || (params.reload)) {
    //   state.loading[params.type] = true;
    //   //params.params.token = rootState.token;
    //   doGet({
    //     url: param.url,
    //     data: params.params,
    //     headers: { Authorization: rootState.token },
    //     okcb: (json) => {
    //       commit('setState', { type: params.type, loading: params.loading || params.type, json: json || (params.list ? [] : {}) });
    //     },
    //     errcb: (data) => {
    //       params && params.callback && (params.callback.call(this, data || '服务器错误！'));
    //       state.loading[params.type] = false;
    //     }
    //   });
      // axios.get(param.url, {params: params.params, headers:{Authorization: rootState.token}})
      //   .then((response) => {
      //     const json = response.data;
      //     if (json && json[types.KEY_STATUS] === types.CODE_SUCCESS) {
      //       commit('setState', { type: params.type, loading: params.loading || params.type, json: json.obj ? json.obj : (params.list ? [] : {}) });

      //       // params.list
      //       //   ? commit(params.list, json.obj || [])
      //       //   : commit(params.obj, json.obj || {});
      //     } else {
      //       params && params.callback && (params.callback.call(this, json || '服务器错误！'));
      //       state.loading[params.type] = false;
      //     }
      //   })
      //   .catch((response) => {
      //     params && params.callback && (params.callback.call(this, response.data || '服务器错误！'));
      //     state.loading[params.type] = false;
      //   });
    // }
  },
  [types.BASE_LOAD.xiaoquList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'xiaoquList', url:'sys/code/loadBase/xiaoqu', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.sexList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'sexList', url:'sys/code/loadBase/sex', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.sexMap] ({ dispatch }, param = {}) {
    dispatch(types.BASE_LOAD.sexList, param);
  },
  [types.BASE_LOAD.ccList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'ccList', url:'sys/code/loadBase/cc', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.xjList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'xjList', url:'sys/code/loadBase/xj', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.xjMap] ({ dispatch }, param = {}) {
    dispatch(types.BASE_LOAD.xjList, param);
  },
  [types.BASE_LOAD.xjStatus] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'xjStatus', url:'sys/code/loadBase/xjStatus', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.preconditionList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'preconditionList', url:'sys/code/loadBase/preconditionList', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.sourceMap] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'sourceMap', url:'sys/code/loadBase/source', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.cluestatusMap] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'cluestatusMap', url:'sys/code/loadBase/cluestatus', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.visitstatusMap] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'visitstatusMap', url:'sys/code/loadBase/visitstatus', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.visittypeMap] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'visittypeMap', url:'sys/code/loadBase/visittype', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.idcardtype] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'idcardtype', url:'sys/code/loadBase/idcardtype', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.bodystate] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'bodystate', url:'sys/code/loadBase/bodystate', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.zyList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'zyList', url:'sys/code/loadBase/zy', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.yxList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'yxList', url:'sys/code/loadBase/yx', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.kcList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'kcList', url:'sys/code/loadBase/kc', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.xlMap] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'xlMap', url:'sys/code/loadBase/xl', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.zslsList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'zslsList', url:'sys/code/loadBase/zsls', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.njList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'njList', url:'sys/code/loadBase/nj', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.bfeeList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'bfeeList', url:'sys/code/loadBase/fee', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.feetagList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'feetagList', url:'sys/code/loadBase/feetag', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.feetagList2] ({ dispatch }, param = {}) {
    dispatch(types.BASE_LOAD.feetagList, param);
  },
  [types.BASE_LOAD.paymethodMap] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'paymethodMap', url:'sys/code/loadBase/paymethod', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.exportList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'exportList', url:'sys/code/loadBase/bexport', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.sealtypeList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'sealtypeList', url:'sys/code/loadBase/sealtype', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.contracttypeList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'contracttypeList', url:'sys/code/loadBase/contracttype', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.contractstateList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'contractstateList', url:'sys/code/loadBase/contractstate', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.mzList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'mzList', url:'sys/code/loadBase/mz', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.zzmmList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'zzmmList', url:'sys/code/loadBase/zzmm', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.pxitemList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'pxitemList', url:'sys/code/loadBase/pxitem', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.pxitemTree] ({ dispatch }, param = {}) {
    dispatch(types.BASE_LOAD.pxitemList, param);
  },
  [types.BASE_LOAD.empList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'empList', url:'sys/employee/listAll', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.departList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'departList', url:'sys/depart/list', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.goodscateList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'goodscateList', url:'sys/code/loadBase/goodscate', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.goodsbrandList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'goodsbrandList', url:'sys/code/loadBase/goodsbrand', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.goodsunitList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'goodsunitList', url:'sys/code/loadBase/goodsunit', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.jilucateList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'jilucateList', url:'sys/code/loadBase/jilucate', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.huiyishicateList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'huiyishicateList', url:'sys/code/loadBase/huiyishicate', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.huiyishiroomList] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'huiyishiroomList', url:'sys/code/loadBase/huiyishiroom', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.scoreterm] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'scoreterm', url:'sys/code/loadBase/scoreterm', list: true});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.scorekstype] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'scorekstype', url:'sys/code/loadBase/scorekstype', list: true});
    dispatch('loadOthers', param);
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
